<template>
    <!-- 过渡动画 -->
    <transition name="sliderUpHideRight">
        <div class="img-view" @click="bigImg">
            <!-- 遮罩层 -->
            <!--<div class="img-layer"></div>-->
            <div class="img">
                <img :src="imgSrc">
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        props: ['imgSrc'],
        methods: {
            bigImg() {
                // 发送事件
                this.$emit('clickit')
            }
        }
    }
</script>
<style scoped>
    /*动画*/

    .sliderUpHideRight-enter-to,.sliderUpHideRight-leave-to{
        transition: all 0.3s;
    }
    .sliderUpHideRight-enter{
        transform:translate3d(0,100%,0);
        opacity: 0;
    }
    .sliderUpHideRight-leave-to{
        transform:translate3d(0,100%,0);
        opacity: 0;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: all .2s linear;

        /*transform: translate3D(0, 0, 0);*/
    }

    .fade-enter,
    .fade-leave-active {
        /*transform: translate3D(100%, 0, 0);*/
    }


    /* bigimg */

    .img-view {
        position: relative;
        width: 100%;
        height: 100%;
    }

    /*遮罩层样式*/
    .img-view {
        max-width: 100%;
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 1);
        width: 100%;
        /*overflow: auto;*/
        /*height: 100%;*/
        /*overflow: hidden;*/
    }

    /*不限制图片大小，实现居中*/
    .img-view .img{
        height: 100vh;
        overflow: auto;
    }
    .img-view .img img {
        max-width: 100%;
        display: block;
        /*position: absolute;*/
        /*left: 0;*/
        /*right: 0;*/
        /*top: 0;*/
        /*bottom: 0;*/
        /*margin: auto;*/
        /*z-index: 1000;*/
    }
</style>


// WEBPACK FOOTER //
// src/components/big-img.vue